import { render, staticRenderFns } from "./confirmCandidate.vue?vue&type=template&id=121058d6&scoped=true"
import script from "./confirmCandidate.vue?vue&type=script&lang=js"
export * from "./confirmCandidate.vue?vue&type=script&lang=js"
import style0 from "./confirmCandidate.vue?vue&type=style&index=0&id=121058d6&prod&lang=scss&scoped=true"
import style1 from "./confirmCandidate.vue?vue&type=style&index=1&id=121058d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121058d6",
  null
  
)

export default component.exports